// Nieuw toernooi aanvragen, eigenaarschap aanbieden en aanvaarden.
//
// Een toernooi is een eigen organisatie. Owner word je alleen door zelf de
// voorwaarden te aanvaarden: bij een goedgekeurde aanvraag en bij een
// overdracht. De database controleert dat (public.eigendom_aanvaarden); dit
// scherm legt het voor.
import { getClient } from '../data/supabase.js';
import { state } from '../state.js';
import { t, locale } from '../lib/i18n.js';
import { esc } from '../lib/format.js';
import { toast } from '../ui/toast.js';

const sb = () => getClient();

export function eigendomFout(e) {
  const m = String(e?.message || e || '').match(/eigendom:([a-z_]+)/);
  return m ? t('eigendom.fout.' + m[1]) : t('alg.fout', { melding: e?.message || String(e) });
}
const datum = iso => iso ? new Date(iso).toLocaleDateString(locale(), { day: 'numeric', month: 'short', year: 'numeric' }) : '';

// ── Aanvaarden: voorwaarden, naam, functie, bevoegdheid ────────────────────
export async function aanvaardFormulier(el, aanbod, naAfloop) {
  const { data, error } = await sb().from('terms_documents')
    .select('id, kind, version, content_url, applies_to_roles').eq('is_current', true);
  const docs = (data || []).filter(d => (d.applies_to_roles || []).includes('owner'));
  if (error || !docs.length) {
    el.innerHTML = `<div class="banner banner-amber"><i class="ti ti-alert-triangle"></i><span>${esc(t('eigendom.fout.geen_voorwaarden'))}</span></div>`;
    return;
  }
  el.innerHTML = `<div class="eigendom-aanvaard">
    <p class="start-uitleg">${esc(t('eigendom.aanvaard.uitleg'))}</p>
    ${docs.map(d => `<label class="eigendom-doc"><input type="checkbox" data-doc="${d.id}">
      <span>${esc(t('eigendom.doc.' + d.kind))} <span class="start-sub">${esc(d.version)}</span>
      ${d.content_url ? ` &middot; <a href="${esc(d.content_url)}" target="_blank" rel="noopener">${esc(t('eigendom.lezen'))}</a>` : ''}</span></label>`).join('')}
    <div class="form-row" style="margin-top:10px">
      <div class="form-group"><label class="form-label">${esc(t('eigendom.naam'))}</label><input class="form-input" name="naam" autocomplete="name"></div>
      <div class="form-group"><label class="form-label">${esc(t('eigendom.functie'))}</label><input class="form-input" name="functie" placeholder="${esc(t('eigendom.functie.voorbeeld'))}"></div>
    </div>
    <label class="eigendom-doc"><input type="checkbox" name="bevoegd"> <span>${esc(t('eigendom.bevoegd'))}</span></label>
    <button type="button" class="btn btn-primary" data-eigendom="aanvaarden" style="margin-top:10px"><i class="ti ti-check"></i> ${esc(t('eigendom.aanvaarden'))}</button>
  </div>`;
  el.querySelector('[data-eigendom="aanvaarden"]').onclick = async () => {
    const aangevinkt = [...el.querySelectorAll('[data-doc]:checked')].map(c => c.dataset.doc);
    if (aangevinkt.length !== docs.length) { toast(t('eigendom.fout.voorwaarden_gewijzigd'), 'error'); return; }
    const { data: org, error: fout } = await sb().rpc('eigendom_aanvaarden', {
      p_aanbod: aanbod.id, p_naam: el.querySelector('[name="naam"]').value, p_functie: el.querySelector('[name="functie"]').value,
      p_documenten: aangevinkt, p_bevoegd: el.querySelector('[name="bevoegd"]').checked,
    });
    if (fout) { toast(eigendomFout(fout), 'error'); return; }
    if (!org) { toast(t('eigendom.verlopen'), 'error'); return; }
    toast(t('eigendom.welkom', { naam: aanbod.organisatie }), 'success');
    await naAfloop(org);
  };
}

// ── Aanvragen ──────────────────────────────────────────────────────────────
export function aanvraagFormulier(el, naAfloop) {
  const soort = (w, gekozen) => `<label style="display:flex;align-items:center;gap:6px;font-size:13px">
      <input type="radio" name="tsoort" value="${w}" ${gekozen ? 'checked' : ''}> ${esc(t('eigendom.soort.' + w))}</label>`;
  el.innerHTML = `<div class="form-row">
      <div class="form-group"><label class="form-label">${esc(t('eigendom.aanvraag.naam'))}</label><input class="form-input" name="tnaam" placeholder="${esc(t('eigendom.aanvraag.naam.voorbeeld'))}"></div>
      <div class="form-group"><label class="form-label">${esc(t('eigendom.aanvraag.land'))}</label><input class="form-input" name="tland" maxlength="2" placeholder="NL"></div>
    </div>
    <div class="form-group"><label class="form-label">${esc(t('eigendom.aanvraag.soort'))}</label>
      <div style="display:flex;gap:16px;flex-wrap:wrap">${soort('club', true)}${soort('organisator', false)}${soort('bond', false)}</div></div>
    <div class="form-row">
      <div class="form-group"><label class="form-label">${esc(t('eigendom.aanvraag.toernooi'))}</label><input class="form-input" name="ttoernooi" placeholder="${esc(t('eigendom.aanvraag.toernooi.voorbeeld'))}"></div>
      <div class="form-group"><label class="form-label">${esc(t('eigendom.aanvraag.datum'))}</label><input class="form-input" type="date" name="tdatum"></div>
    </div>
    <div class="form-group"><label class="form-label">${esc(t('eigendom.aanvraag.toelichting'))}</label>
      <textarea class="form-input" name="ttoelichting" rows="2" placeholder="${esc(t('eigendom.aanvraag.toelichting.voorbeeld'))}"></textarea></div>
    <button type="button" class="btn btn-primary btn-sm" data-eigendom="aanvragen"><i class="ti ti-send"></i> ${esc(t('eigendom.aanvraag.versturen'))}</button>`;
  el.querySelector('[data-eigendom="aanvragen"]').onclick = async () => {
    const waarde = n => el.querySelector(`[name="${n}"]`).value;
    const gekozen = el.querySelector('[name="tsoort"]:checked')?.value || 'organisator';
    const { error } = await sb().rpc('organisatie_aanvragen', {
      p_naam: waarde('tnaam'), p_types: [gekozen], p_land: waarde('tland') || null,
      p_toernooi: waarde('ttoernooi') || null, p_datum: waarde('tdatum') || null, p_toelichting: waarde('ttoelichting') || null,
    });
    if (error) { toast(eigendomFout(error), 'error'); return; }
    toast(t('eigendom.aanvraag.verstuurd'), 'success');
    await naAfloop();
  };
}

// ── Overdragen, op de pagina Gebruikersbeheer ──────────────────────────────
export async function renderOverdracht(el) {
  if (!el) return;
  const { data } = await sb().from('ownership_offers').select('*')
    .eq('organisation_id', state.currentOrgId).eq('status', 'open');
  const open = (data || [])[0];
  el.innerHTML = `
    <div style="font-size:12px;font-weight:600;color:var(--text-2);margin-bottom:4px">${esc(t('eigendom.overdragen'))}</div>
    <div style="font-size:12px;color:var(--text-3);margin-bottom:10px">${esc(t('eigendom.overdragen.uitleg'))}</div>
    ${open ? `<div class="banner banner-blue"><i class="ti ti-hourglass"></i><span>${esc(t('eigendom.overdragen.open', { naar: open.naar_email, datum: datum(open.expires_at) }))}</span></div>
      <button type="button" class="btn btn-default btn-sm" data-eigendom="intrekken" data-id="${open.id}"><i class="ti ti-x"></i> ${esc(t('eigendom.intrekken'))}</button>` : `
    <div class="form-row">
      <div class="form-group"><label class="form-label">${esc(t('eigendom.overdragen.aan'))}</label><input class="form-input" type="email" name="onaar"></div>
      <div class="form-group"><label class="form-label">${esc(t('eigendom.overdragen.daarna'))}</label>
        <select class="form-input" name="oblijf"><option value="admin">${esc(t('eigendom.blijf.admin'))}</option><option value="weg">${esc(t('eigendom.blijf.weg'))}</option></select></div>
    </div>
    <div class="form-group"><label class="form-label">${esc(t('bond.reden'))}</label><input class="form-input" name="oreden" placeholder="${esc(t('eigendom.overdragen.voorbeeld'))}"></div>
    <button type="button" class="btn btn-default btn-sm" data-eigendom="overdragen"><i class="ti ti-transfer"></i> ${esc(t('eigendom.overdragen.knop'))}</button>`}`;
  el.onclick = async e => {
    const k = e.target.closest('[data-eigendom]');
    if (!k) return;
    if (k.dataset.eigendom === 'intrekken') {
      const { error } = await sb().rpc('eigendom_intrekken', { p_aanbod: k.dataset.id });
      if (error) { toast(eigendomFout(error), 'error'); return; }
    }
    if (k.dataset.eigendom === 'overdragen') {
      const w = n => el.querySelector(`[name="${n}"]`).value;
      const { error } = await sb().rpc('eigendom_overdragen', { p_org: state.currentOrgId, p_email: w('onaar'), p_reden: w('oreden'), p_oude_owner: w('oblijf') });
      if (error) { toast(eigendomFout(error), 'error'); return; }
      toast(t('eigendom.overdragen.verstuurd'), 'success');
    }
    await renderOverdracht(el);
  };
}
